import styled from "@emotion/styled";

export const PrimaryButton = styled.button`
  padding: 12px 20px;
  color: #d8d8d8;
  background: #1564ff;
  width: fit-content;
  font-size: 14px;
  line-height: 14px;
`;
